import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { RolePermissionsService } from './../services/role-permissions.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private rolePermissionsService: RolePermissionsService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
        : Observable<boolean> | Promise<boolean> | boolean {
        let allow: boolean = false;
        let permissions = route.data["permissions"] as Array<string>;

        allow = this.rolePermissionsService.hasPermissionIn(permissions);

        return allow;
    }
}
